<template>
  <div class="uploadContainer">
    <div class="ios-safe-upload">
      <!-- 保持原生 input 可见但透明 -->
      <!--   微信浏览器不支持Android，鸿蒙文件多选，仅支持image类型多选   -->
      <input
        v-if="wechatInAndroid"
        type="file"
        class="native-input"
        ref="fileInput"
        @change="handleFileSelect($event)"
      />
      <input
        v-else
        type="file"
        class="native-input"
        ref="fileInput"
        multiple
        @change="handleFileSelect($event)"
      />
      <!-- 自定义样式层 -->
      <img
        class="submitBtn_icon"
        src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_uploadBtn.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      // 存储用户选择的文件
      selectedFiles: [],
      // 格式化后的文件
      files: [],
      // 是否处于Android端微信浏览器
      wechatInAndroid: false,
      // 文件类型映射 默认仅图片
      allowedFileTypes: ["image"],
      // 支持上传的文件分类型控制大小
      fileUploadConfig: [],
      // 文件类型映射表
      fileTypeMap: new Map(),
    };
  },
  mounted() {
    const userAgent = navigator.userAgent;
    this.wechatInAndroid =
      /Android/i.test(userAgent) && /MicroMessenger/i.test(userAgent);
  },
  methods: {
    // 文件上传
    handleFileSelect(event) {
      console.log("========触发handleFileSelect files");
      // 文件类型映射
      this.initFileCategory();
      this.allowedFileTypes = this.$store.state.allowedFileTypes;
      this.fileUploadConfig = this.$store.state.fileUploadConfig;
      if (!event || !event.target || !event.target.files) {
        this.$toast("无效的文件，请重新选择");
        return;
      }
      const files = Array.from(event.target.files);
      console.log("========handleFileSelect files", files.length);
      let filterFiles = [];
      if (!files.length) return;
      //过滤掉超大的文件
      for (const key in files) {
        const file = files[key];
        // 获取文件扩展名
        const fileExtension = file.name.split(".").pop().toUpperCase();
        // 判断文件是否支持
        if (this.isFileSupported(fileExtension)) {
          const maxSizeInBytes = this.getMaxSizeForFileType(file);
          console.log("========", maxSizeInBytes);
          if (file.size > maxSizeInBytes) {
            this.$toast("文件过大，暂不支持发送");
          } else {
            filterFiles.push(file);
          }
        } else {
          this.$toast(`已过滤不支持上传的文件`);
        }
      }
      let updates = [];
      filterFiles.forEach((file, index) => {
        if (file.type.startsWith("image/")) {
          this.previewFile(file).then((previewUrl) => {
            updates.push({
              type: "image",
              file: file,
              url: previewUrl,
              id: this.generateUUID(),
            });
            if (updates.length === filterFiles.length) {
              this.updateFiles(updates);
            }
          });
        } else {
          updates.push({
            type: file.type.startsWith("video/")
              ? "video"
              : file.type.startsWith("audio/")
              ? "audio"
              : "file",
            file: file,
            id: this.generateUUID(),
            progress: 0,
          });
          // 如果全部都是非图片文件，则直接更新
          if (updates.length === filterFiles.length) {
            this.updateFiles(updates);
          }
        }
      });
      // 清空文件输入框的值
      this.$refs.fileInput.value = "";
    },

    // 获取预览文件地址，并返回Promise
    previewFile(file) {
      return new Promise((resolve) => {
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.readAsDataURL(file); // 用于图像预览
        } else {
          resolve(URL.createObjectURL(file)); // 对于视频文件，直接设置URL
        }
      });
    },

    //每个文件做标记
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    // 更新files数据
    updateFiles(updates) {
      this.$emit("sendFilesData", updates);
    },

    // 处理文件
    //检测是否超出该类文件最大限制
    getMaxSizeForFileType(file) {
      const MB = 1024 * 1024; // 转换系数
      const type = file.type;
      if (type.startsWith("image/")) {
        // 图片类
        return this.fileUploadConfig.image_file_size_limit * MB;
      } else if (
        type === "application/pdf" ||
        type === "application/msword" ||
        type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        type === "application/vnd.ms-excel" ||
        type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        type === "application/vnd.ms-powerpoint" ||
        type ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ) {
        // 文档类
        return this.fileUploadConfig.file_size_limit * MB;
      } else if (type.startsWith("audio/")) {
        // 音频
        return this.fileUploadConfig.audio_file_size_limit * MB;
      } else if (type.startsWith("video/")) {
        // 视频类
        return this.fileUploadConfig.video_file_size_limit * MB;
      } else {
        return this.fileUploadConfig.video_file_size_limit * MB;
      }
    },
    //同步后端的文件类型处理
    initFileCategory() {
      // 使用 Map 存储文件类型映射
      // 文档类型
      const documents = [
        "TXT",
        "MD",
        "MARKDOWN",
        "PDF",
        "HTML",
        "XLSX",
        "XLS",
        "DOCX",
        "CSV",
        "EML",
        "MSG",
        "PPTX",
        "PPT",
        "XML",
        "EPUB",
      ];
      documents.forEach((type) => this.fileTypeMap.set(type, "document"));
      // 图片类型
      const images = ["JPG", "JPEG", "PNG", "GIF", "WEBP", "SVG"];
      images.forEach((type) => this.fileTypeMap.set(type, "image"));
      // 音频类型
      const audios = ["MP3", "M4A", "WAV", "WEBM", "AMR"];
      audios.forEach((type) => this.fileTypeMap.set(type, "audio"));
      // 视频类型
      const videos = ["MP4", "MOV", "MPEG", "MPGA"];
      videos.forEach((type) => this.fileTypeMap.set(type, "video"));
    },

    // 判断文件是否支持
    isFileSupported(fileExtension) {
      // 获取文件的分类
      const category = this.fileTypeMap.get(fileExtension.toUpperCase());
      // 如果分类存在且在支持的分类列表中，则返回 true
      return category && this.allowedFileTypes.includes(category);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./uploadFileForPC.scss";
</style>
